const headerSearch = document.querySelector('.header-search');

if (headerSearch) {
  const headerOverlay = document.querySelector('.header-search__overlay');
  const input = headerSearch.querySelector('.mod-input__field');
  const inputParent = headerSearch.querySelector('.mod-input');
  const ajaxResults = headerSearch.querySelector('.header-search__ajax-results');
  const defaultResults = headerSearch.querySelector('.header-search__default-results');
  const notFound = headerSearch.querySelector('.header-search__not-found');
  const notFoundTitle = notFound ? notFound.querySelector('.header-search__title') : null;
  const submitButton = headerSearch.querySelector('.header-search__submit');

  attachEvent('.header-search .mod-input__field', 'input', (ev) => {
    ev.target.closest('.header-search').classList.toggle('filled', !!ev.target.value);
  });

  input.addEventListener('mouseenter', () => headerSearch.classList.add('is-hovered'));
  input.addEventListener('mouseleave', () => headerSearch.classList.remove('is-hovered'));

  const resetSearch = () => {
    input.value = '';
    input.blur();
    headerSearch.classList.remove('filled', 'is-no-results');
    inputParent.classList.remove('is-focused');
    if (ajaxResults) {
      ajaxResults.innerHTML = '';
      ajaxResults.classList.add('hide');
    }
    if (defaultResults) defaultResults.classList.remove('hide');
    if (notFound) notFound.classList.add('hide');
    if (submitButton) submitButton.classList.remove('is-disabled');
  };

  attachEvent('.header-search__delete', 'click', () => {
    resetSearch();
  });

  attachEvent('.header-search__recommended-item', 'click', (ev) => {
    input.value = ev.target.textContent.trim();
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('keyup', { bubbles: true }));
  });

  // **************************************************
  // Open dropdown on focus
  new MutationObserver(() => {
    if (inputParent.classList.contains('is-focused')) {
      headerSearch.classList.add('is-active');
      headerOverlay.classList.add('is-active');
      toggleBodyScrollLock(true);
    }
  }).observe(inputParent, { attributeFilter: ['class'] });

  // **************************************************
  // Close dropdown
  attachEvent('.header-search__overlay', 'click', (ev) => {
    if (!headerSearch.contains(ev.target)) {
      headerSearch.classList.remove('is-active', 'is-open');
      headerOverlay.classList.remove('is-active');
      toggleBodyScrollLock(false);
    }
  });

  attachEvent('.header-search__close', 'click', () => {
    resetSearch();
    headerSearch.classList.remove('is-active', 'is-hovered', 'is-open');
    headerOverlay.classList.remove('is-active');
    toggleBodyScrollLock(false);
  });

  // **************************************************
  // Live search
  let lastSearchTerm = '';

  const updateSearchVisibility = (hasResults) => {
    if (defaultResults) defaultResults.classList.add('hide');
    if (notFound) notFound.classList.toggle('hide', hasResults);
    if (ajaxResults) ajaxResults.classList.toggle('hide', !hasResults);
    headerSearch.classList.toggle('is-no-results', !hasResults);
    if (submitButton) submitButton.classList.toggle('is-disabled', !hasResults);
  };

  const searchHeaderPosts = (value, key = '') => {
    if (value === lastSearchTerm) return;
    lastSearchTerm = value;

    if (!value || value === '////') {
      if (ajaxResults) {
        ajaxResults.innerHTML = '';
        ajaxResults.classList.add('hide');
      }
      if (defaultResults) defaultResults.classList.remove('hide');
      if (notFound) notFound.classList.add('hide');
      headerSearch.classList.remove('is-no-results');
      if (submitButton) submitButton.classList.remove('is-disabled');
      return;
    }

    axios
      .post(localData.apiURL, {
        action: 'searchHeaderPosts',
        keyword: value,
        lang: localData.lang,
        keyboardKey: key,
      })
      .then((response) => {
        const html = response?.data?.data?.html;
        const noResultsText = response?.data?.data?.no_results_text || '';

        if (html) {
          if (ajaxResults) ajaxResults.innerHTML = html;
          updateSearchVisibility(true);
        } else {
          if (ajaxResults) ajaxResults.innerHTML = '';
          if (notFoundTitle) notFoundTitle.textContent = noResultsText;
          updateSearchVisibility(false);
        }
      })
      .catch(() => {
        if (ajaxResults) ajaxResults.innerHTML = '';
        updateSearchVisibility(false);
      });
  };

  input.addEventListener(
    'keyup',
    debounce((e) => {
      if (e.key === 'Escape') return;

      const value = input.value.trim();

      if (value.length >= 3) {
        searchHeaderPosts(value, e.key);
      } else if (value.length === 0) {
        searchHeaderPosts('', '');
      }
    }, 200),
  );
}
